import { useCallback } from 'react';

const STORAGE_KEY = 'recentlyViewedProtocols';
const MAX_RECENT_PROTOCOLS = 10;

const useRecentProtocolsManager = () => {
  const updateLocalStorage = useCallback((updatedProtocols) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedProtocols));
  }, []);

  const getLastRecentlyUsedProtocols = useCallback(() => {
    const storedProtocols = localStorage.getItem(STORAGE_KEY);
    if (storedProtocols) {
      try {
        return JSON.parse(storedProtocols);
      } catch (e) {
        console.error("Failed to parse recently used protocols:", e);
        return [];
      }
    }
    return [];
  }, []);

  const protocolAccessed = useCallback((protocolId) => {
    const currentTime = new Date().toISOString();
    const recentProtocols = getLastRecentlyUsedProtocols();
    const updatedProtocols = recentProtocols?.filter(p => p.id !== protocolId) || [];
    updatedProtocols.unshift({ id: protocolId, lastAccessed: currentTime });

    if (updatedProtocols.length > MAX_RECENT_PROTOCOLS) {
      updatedProtocols.pop();
    }
    updateLocalStorage(updatedProtocols);
  }, [getLastRecentlyUsedProtocols, updateLocalStorage]);

  return {
    protocolAccessed,
    getLastRecentlyUsedProtocols,
  };
};

export default useRecentProtocolsManager;